import { Box, LinearProgress, Typography } from '@material-ui/core'
import clsx from 'clsx'

import { useStyles } from './styles'

interface LinearProgressWithLabelProps {
  label?: string
  progressValue: number
  fileSize: string
  isError?: boolean
}

export const LinearProgressWithLabel = ({
  label,
  progressValue,
  fileSize,
  isError,
}: LinearProgressWithLabelProps) => {
  const classes = useStyles()

  const progressCompleted: boolean = progressValue === 100

  return (
    <Box className={classes.processingFiles}>
      <Box display='flex' justifyContent='space-between'>
        <Typography
          variant={'body1'}
          className={clsx({ [classes.textColorCompleted]: progressCompleted })}
        >
          {progressCompleted
            ? `Carregado - ${progressValue}%`
            : `Carregando - ${progressValue.toFixed(0)}%`}
        </Typography>
        <span>{fileSize}</span>
      </Box>
      <Box className={clsx({ [classes.borderCompleted]: progressCompleted })}>
        <Typography variant={'body2'}>{label}</Typography>
        {!progressCompleted && (
          <LinearProgress
            aria-label={`Progresso do ${label}`}
            variant={progressValue || isError ? 'determinate' : 'indeterminate'}
            value={progressValue}
          />
        )}
      </Box>
    </Box>
  )
}
